import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EntitiesService } from 'src/app/services/entities/entities.service';
import { Entity } from '../../../../classes/entity.class';
import { Hiring } from '../../../../classes/hiring';
import { HiringService } from '../../../../services/hiring.service';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-entity-input',
    standalone: false,
    templateUrl: './entity-input.component.html',
    styleUrl: './entity-input.component.scss',
})
export class EntityInputComponent extends InputComponent implements OnInit {
    private entitiesService = inject(EntitiesService);
    private hiringService = inject(HiringService);
    entities$ = this.entitiesService.getByType(this.field.dataFilter as any[]);
    hiring$: Observable<Hiring[]>;

    fcHiringId: FormControl<number>;
    fcName: FormControl<string>;

    entity: WritableSignal<Entity> = signal(null);

    ngOnInit() {
        const value$ = this.fc.valueChanges;
        this.subscriptions.add(
            combineLatest([value$, this.entities$]).subscribe(([entityId, entities]) => {
                const entity = entities.find(e => e.id === entityId);
                if (this.fc.parent.value?.entity_id !== entityId && !this.fc?.parent?.get('driver_user_id')?.value) {
                    if (entity?.driver_user_id) {
                        this.formData.form.controls.planningHas.controls
                            .filter(c => c.controls.phe.get('entity_id').value === entityId)
                            .forEach(c => {
                                c.controls.phe.get('driver_user_id').setValue(entity.driver_user_id);
                            });
                    }
                }
                if (entity?.entitytypes?.length && !entity.use_once) {
                    this.hiring$ = combineLatest(
                        entity.entitytypes.map(et => this.hiringService.getByType(et.key))
                    ).pipe(
                        map(results =>
                            results.flat().filter((h, index, self) => self.findIndex(x => x.id === h.id) === index)
                        )
                    );
                }
                this.entity.set(entity);
            })
        );
        if (this.fc.parent.get('hiring_id')) {
            this.fcHiringId = this.fc.parent.get('hiring_id') as FormControl<number>;
        }
        if (this.fc.parent.get('name')) {
            this.fcName = this.fc.parent.get('name') as FormControl<string>;
        }
    }
}
